import { Grid } from "@chakra-ui/react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import CardComponent from "../Components/CardComponent";
import { AuthContext } from "../Contexts/AuthContextProvider";

const Recipes = () => {
  const [data, setData] = useState([]);

  const { token } = React.useContext(AuthContext);

  // console.log(data);
  const getData = async () => {
    await fetch("https://dull-tan-drill-gear.cyclic.app/recipes", {
      headers: {
        Authorization: token,
      },
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Grid
      gridTemplateColumns={{
        sm: "repeat(2,1fr)",
        md: "repeat(3,1fr)",
        lg: "repeat(3,1fr)",
      }}
      gap={"20px"}
    >
      {data && data.map((el) => <CardComponent {...el} getData={getData} />)}
    </Grid>
  );
};

export default Recipes;
